export const GENERAL_FEEDBACK_URL = "https://form.jotform.com/251211056660042";
